// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"c49d5d91","703":"abd3e516","787":"ccc0317d"}[chunkId] + ".chunk.js";
};